import { X } from 'lucide-react';

export default function AgentEditingBar({
  onCancel,
}: {
  onCancel: () => void;
}) {
  return (
    <div className="flex w-full items-center justify-between gap-s px-m">
      <p className="text-body-sm font-medium text-gray">Editing message</p>
      <button
        type="button"
        className="btn-reset grid size-6 place-items-center text-gray transition-colors ease-[ease] hover:text-purple-default"
        aria-label="Cancel editing"
        onClick={onCancel}
      >
        <X size={16} />
      </button>
    </div>
  );
}
